(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('countdown-timer')) return;

    var UNITS = [
      ['days', 86400],
      ['hours', 3600],
      ['minutes', 60],
      ['seconds', 1],
    ];

    function format(unit, value) {
      if (unit === 'days' || value > 99) return String(value);
      return String(value).padStart(2, '0');
    }

    class CountdownTimer extends HTMLElement {
      connectedCallback() {
        this.end = Number(this.dataset.end) * 1000;
        if (!this.end) return;

        // Only own values, not those of a nested countdown
        var self = this;
        this.values = Array.prototype.filter.call(
          this.querySelectorAll('[data-countdown-unit]'),
          function (el) { return el.closest('countdown-timer') === self; }
        );
        this.units = UNITS.filter(function (u) {
          return self.values.some(function (el) { return el.dataset.countdownUnit === u[0]; });
        });

        this.tick = this.tick.bind(this);
        this.tick();
        if (this.end > Date.now()) this.interval = setInterval(this.tick, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        var rest = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
        var text = {};

        this.units.forEach(function (u) {
          var value = Math.floor(rest / u[1]);
          rest -= value * u[1];
          text[u[0]] = format(u[0], value);
        });

        this.values.forEach(function (el) {
          var t = text[el.dataset.countdownUnit];
          if (el.textContent !== t) el.textContent = t;
        });

        if (this.end <= Date.now()) {
          clearInterval(this.interval);
          var inEditor = window.Shopify && window.Shopify.designMode;
          if (this.dataset.whenFinished === 'hide' && !inEditor) {
            this.classList.add('countdown-block--finished');
          }
        }
      }
    }

    customElements.define('countdown-timer', CountdownTimer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["visibility"] && !Shopify.designMode) return;
  try {
    /*
   * Collapses padding / min-height left behind by hidden visibility blocks.
   * Bundled once per page by Shopify (not once per block), runs once on load,
   * checks each wrapper/section only once and does all layout reads before any writes.
   */
  (function () {
    if (window.__visibilityCollapse) return;
    window.__visibilityCollapse = true;

    var SKIP_TAGS = { STYLE: 1, SCRIPT: 1, LINK: 1, TEMPLATE: 1, NOSCRIPT: 1 };

    function isIgnorable(el) {
      if (SKIP_TAGS[el.tagName]) return true;
      if (el.hasAttribute('data-visibility-hidden')) return true;
      var cls = el.getAttribute('class') || '';
      return cls.indexOf('custom-section-background') !== -1;
    }

    // true if any leaf element inside root has a rendered box
    function hasVisibleContent(root) {
      var all = root.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (el.children.length > 0 || isIgnorable(el)) continue;
        var rect = el.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) return true;
      }
      return false;
    }

    function setImportant(el, props) {
      for (var key in props) el.style.setProperty(key, props[key], 'important');
    }

    function run() {
      var markers = document.querySelectorAll('[data-visibility-hidden]');
      if (!markers.length) return;

      var wrappers = new Set();
      var sections = new Set();

      markers.forEach(function (marker) {
        var wrapper = marker.parentElement;
        if (wrapper && !wrapper.hasAttribute('data-visibility-checked')) wrappers.add(wrapper);
        var section = marker.closest('[data-testid="ui-test-section"]');
        if (section && !section.hasAttribute('data-visibility-section-checked')) sections.add(section);
      });

      // Read phase (one layout calculation for all blocks)
      var emptyWrappers = [];
      var emptySections = [];
      wrappers.forEach(function (w) { if (!hasVisibleContent(w)) emptyWrappers.push(w); });
      sections.forEach(function (s) { if (!hasVisibleContent(s)) emptySections.push(s); });

      // Write phase
      emptyWrappers.forEach(function (w) {
        setImportant(w, { padding: '0', gap: '0', 'min-height': '0', 'min-width': '0' });
      });
      emptySections.forEach(function (s) {
        setImportant(s, { '--section-min-height': '0px', 'min-height': '0', padding: '0', margin: '0' });
        s.querySelectorAll('.custom-section-background').forEach(function (bg) {
          setImportant(bg, { display: 'none', height: '0', 'min-height': '0' });
        });
      });
      wrappers.forEach(function (w) { w.setAttribute('data-visibility-checked', 'true'); });
      sections.forEach(function (s) { s.setAttribute('data-visibility-section-checked', 'true'); });
    }

    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }

    // Theme editor: re-check after a section is re-rendered
    document.addEventListener('shopify:section:load', run);
  })();
  } catch(e) { console.error(e); }
})();

})();
